import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { css } from "styled-components";
export function getInnerBtnCss() {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    & {\n      width: 16px;\n      right: 16px;\n      .icon {\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        font-size: 16px;\n      }\n    }\n  "])));
}